import React, { useEffect } from 'react';
import { Flex } from 'rebass/styled-components';
import { Loading, PoliciesCcsV2, PoliciesCcsV1 } from '../components';
import { useAppState } from '../hooks';

const ManagePolicyPage = (props) => {
  const { isCcsV2, isLoading } = useAppState();

  useEffect(() => {
    localStorage.setItem('intent-content-policies-visited', 'true');
  }, []);

  if (isLoading) {
    return (
      <Flex sx={{ width: '100%', height: '100%' }} flexDirection="column" alignItems="center" justifyContent="center">
        <Loading size={24} />
      </Flex>
    );
  }

  return isCcsV2 ? (
    <PoliciesCcsV2 {...props} />
  ) : (
    <PoliciesCcsV1 {...props} />
  );
};

export default ManagePolicyPage;
